import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { HttpClientAdapter } from '../http-client-adapter';
import { HTTP, HTTPResponse } from '@ionic-native/http';
import { parseString } from 'xml2js';

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/bindCallback';

import { HttpOptions } from '../interfaces';

@Injectable()
export class IonicHttpClient extends HttpClientAdapter {

  constructor(
    private http: HTTP
  ) {
    super();
    this.http.setDataSerializer('json');
  }

  get(url: string, params: { [name: string]: string }, options: HttpOptions = {}): Observable<any> {
    let parseFunc: Function;

    if (options.headers && options.headers.accept && options.headers.accept.includes('xml')) {
      parseFunc = this.parseXML;
    } else {
      parseFunc = this.parseResponse;
    }

    return Observable.of({ url, params, options})
      .switchMap(({ url, params, options }) => Observable.fromPromise(this.http.get(url, params, options.headers || {})))
      .mergeMap(response => parseFunc(response))
    ;
  }

  post(url: string, params: { [name: string]: string }, body: any, options: HttpOptions = {}): Observable<any> {
    return Observable.of({ url, params, body, options})
      .switchMap(({ url, params, body, options }) => Observable.fromPromise(this.http.post(url, body, options.headers || {})))
      .mergeMap(response => Observable.of(this.parseResponse(response)))
    ;
  }

  put(url: string, params: { [name: string]: string }, body: any | null, options: HttpOptions = {}): Observable<any> {
    return Observable.of({ url, params, body, options})
      .switchMap(({ url, params, body, options }) => Observable.fromPromise(this.http.put(url, body, options.headers || {})))
      .mergeMap(response => Observable.of(this.parseResponse(response)))
    ;
  }

  patch(url: string, body: any | null, options: HttpOptions = {}): Observable<any> {
    return Observable.of({ url, body, options})
      .switchMap(({ url, body, options }) => Observable.fromPromise(this.http.patch(url, body, options.headers || {})))
      .mergeMap(response => Observable.of(this.parseResponse(response)))
    ;
  }

  delete(url: string, params: { [name: string]: string }, options: HttpOptions = {}): Observable<any> {
    return Observable.of({ url, params, options})
      .switchMap(({ url, params, options }) => Observable.fromPromise(this.http.delete(url, params, options.headers || {})))
      .mergeMap(response => Observable.of(this.parseResponse(response)))
    ;
  }

  private parseResponse(response: HTTPResponse) {
    return Observable.of(JSON.parse(response.data));
  }

  private parseXML(response: HTTPResponse) {
    console.debug(response);
    var observableParseString = <any> Observable.bindCallback(parseString);
    return observableParseString(response.data);
  }
}
